import { IMGURL } from "@/config";
/**
 * 获取Token
 */
export const getToken = () => {
    return JSON.parse(window.localStorage.getItem('token'));
}

/*
 * 机构类型
 * */
export const orgTypes = () => {
    return [
        { type: 6, name: '协调中心' },
        { type: 2, name: '认证培训机构' },
        { type: 3, name: '实习基地' },
        { type: 4, name: '考场' },
        { type: 5, name: '产教融合基地' },
    ]
}

export const bdEditConfig = () => {
    return {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 600,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: IMGURL + '/editor/controller.php',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
    }
}

/*
 * 到期时间
 * */
export const dueDate = () => {
    return [
        { type: 1, name: '1年' },
        { type: 2, name: '2年' },
        { type: 3, name: '3年' },
    ]
}

/*
 * 协调中心类型
 * */
export const xtTypes = () => {
    return [
        { type: 2, name: '培训协调中心' },
        { type: 3, name: '实习协调中心' },
        { type: 4, name: '考场协调中心' },
        { type: 5, name: '教学协调中心' },
    ]
}

/*
 * 级别类型
 * */
export const levelTypes = () => {
    return [
        { type: 0, name: '全国' },
        { type: 1, name: '省级' },
        { type: 2, name: '地区' },
    ]
}

/*
 * 政治面貌
 * */
export const faceTypes = [
    { value: 1, label: '中共党员' },
    { value: 2, label: '中共预备党员' },
    { value: 3, label: '共青团员' },
    { value: 4, label: '群众' },
]


/*
 * 民族
 * */
export const nationList = [
    { value: 1, label: '汉族' },
    { value: 2, label: '壮族' },
    { value: 3, label: '满族' },
    { value: 4, label: '回族' },
    { value: 5, label: '苗族' },
    { value: 6, label: '维吾尔族' },
    { value: 7, label: '土家族' },
    { value: 8, label: '彝族' },
    { value: 9, label: '蒙古族' },
    { value: 10, label: '藏族' },
    { value: 11, label: '布依族' },
    { value: 12, label: '侗族' },
    { value: 13, label: '瑶族' },
    { value: 14, label: '朝鲜族' },
    { value: 15, label: '白族' },
    { value: 16, label: '哈尼族' },
    { value: 17, label: '哈萨克族' },
    { value: 18, label: '黎族' },
    { value: 19, label: '傣族' },
    { value: 20, label: '畲族' },
    { value: 21, label: '傈僳族' },
    { value: 22, label: '仡佬族' },
    { value: 23, label: '东乡族' },
    { value: 24, label: '高山族' },
    { value: 25, label: '拉祜族' },
    { value: 26, label: '水族' },
    { value: 27, label: '佤族' },
    { value: 28, label: '纳西族' },
    { value: 29, label: '羌族' },
    { value: 30, label: '土族' },
    { value: 31, label: '仫佬族' },
    { value: 32, label: '锡伯族' },
    { value: 33, label: '柯尔克孜族' },
    { value: 34, label: '达斡尔族' },
    { value: 35, label: '景颇族' },
    { value: 36, label: '毛南族' },
    { value: 37, label: '撒拉族' },
    { value: 38, label: '布朗族' },
    { value: 39, label: '塔吉克族' },
    { value: 40, label: '阿昌族' },
    { value: 41, label: '普米族' },
    { value: 42, label: '鄂温克族' },
    { value: 43, label: '怒族' },
    { value: 44, label: '京族' },
    { value: 45, label: '基诺族' },
    { value: 46, label: '德昂族' },
    { value: 47, label: '保安族' },
    { value: 48, label: '俄罗斯族' },
    { value: 49, label: '裕固族' },
    { value: 50, label: '乌孜别克族' },
    { value: 51, label: '门巴族' },
    { value: 52, label: '鄂伦春族' },
    { value: 53, label: '独龙族' },
    { value: 54, label: '塔塔尔族' },
    { value: 55, label: '赫哲族' },
    { value: 56, label: '珞巴族' },

]






/*
 * 考试类型
 * */
export const paper = [
    { value: '', label: '全部' },
    { value: 0, label: '基础+案例' },
    { value: 1, label: '基础' },
    { value: 2, label: '案例' },
]




/*
 * 面试方式
 * */
export const interviewType = [
    { value: '', label: '全部' },
    { value: 1, label: '电话面试' },
    { value: 2, label: '视频面试' },
    { value: 3, label: '现场面试' },
]


/*
 * 数据过滤全部
 * */
export const optionList = (state, arr) => {
    if (state) {
        return arr
    } else {
        return arr.slice(1)
    }
}

/*
 * value转换为label
 * */
export const filesCN = (val, arr) => {
    let _str = arr.filter(item => val === item.value)
    return _str[0].label
}


/**
 * 动态加载百度地图api函数
 * @param {String} ak  百度地图AK，必传
 */
export default function loadBMap(ak) {
    return new Promise(function(resolve, reject) {
        if (typeof window.BMap !== 'undefined') {
            resolve(window.BMap)
            return true
        }
        window.onBMapCallback = function() {
            resolve(window.BMap)
        }
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.src =
            'http://api.map.baidu.com/api?v=3.0&ak=' + ak + '&callback=onBMapCallback'
        script.onerror = reject
        document.head.appendChild(script)
    })
}

export const zhDate = (now, type) => {
    let year = now.getFullYear()
    let month = now.getMonth() + 1
    let date = now.getDate()
    let hour = now.getHours()
    let minute = now.getMinutes()
    let second = now.getSeconds()
    if (type == 1) {
        return year + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute)
    } else if (type == 2) {
        return year + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
    } else if (type == 3) {
        return getzf(hour) + ":" + getzf(minute)
    } else {
        return year + "-" + getzf(month) + "-" + getzf(date)
    }
}

function getzf(num) {
    if (parseInt(num) < 10) {
        num = '0' + num
    }
    return num
}